export const SERVER_DATE_FORMAT = "YYYY-MM-DD"
export const SERVER_HOUR_FORMAT = "HH:mm:ss"
export const SERVER_DATE_AND_HOUR_FORMAT = `${SERVER_DATE_FORMAT} ${SERVER_HOUR_FORMAT}`

export const CLIENT_DATE_FORMAT = "DD.MM.YYYY"
export const CLIENT_HOUR_FORMAT = "HH:mm"
export const CLIENT_DATE_AND_HOUR_FORMAT = `${CLIENT_DATE_FORMAT} ${CLIENT_HOUR_FORMAT}`
export const CLIENT_DATE_SHORTEN_AND_HOUR_FORMAT = `D.M.YYг. ${CLIENT_HOUR_FORMAT}ч.`